import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppToolbarService } from 'src/app/components/toolbar/services/app-toolbar.service';
import { HttpClient } from '@angular/common/http';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

const CST_TEMPS_MS_AVANT_REFRESH = 60000;

@Component({
  selector: 'app-supervisor',
  templateUrl: './supervisor.component.html',
  styleUrls: ['./supervisor.component.css']
})
export class SupervisorComponent implements OnInit, OnDestroy {

  private mTimer: any; // Interval
  private mImgSupervisor: SafeUrl | null = null; // Image su superviseur
  private mBufferMode: 'determinate'|'query' = 'determinate'; // Notification pour l'actualisation

  public listSupervisor: SupervirorInfo[] = [];
  public selectedSupervisor?: number = undefined;

  constructor(private mToolbar: AppToolbarService,
              private mHttp: HttpClient,
              private mSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.mToolbar.toolbarPageTitle = 'Superviseur';
    // Recuperation de la liste des superviseur disponible & Recuperation du superviseur
    this.loadListSupervisor().then(() => this.loadImgSupervisor());
    this.mTimer = setInterval(() => this.loadImgSupervisor(), CST_TEMPS_MS_AVANT_REFRESH);
  }

  ngOnDestroy(): void {
    clearInterval(this.mTimer);
  }

  onSelectSupervisorChange(event: any) {
    this.loadImgSupervisor();
  }

  /**
   * Recuperation de la liste des supervisors
   */
  async loadListSupervisor() {
    this.listSupervisor = (await ArmaServConnection.aGET(this.mHttp, 'GetListSuperviseur')).result[0];
    if (this.listSupervisor.length > 0) {
      this.selectedSupervisor = 0;
      this.loadImgSupervisor();
    }
  }

  async loadImgSupervisor() {
    if (this.selectedSupervisor == undefined)
      return;
    if (this.listSupervisor.length > 0 && this.selectedSupervisor >= 0 && !this.isRefreshingSupervisor) {
      this.mBufferMode = 'query';
      try {
        this.mImgSupervisor = await ArmaServConnection.getSafeUrlImgFromDatasnap(this.mHttp, this.mSanitizer, 'GetImageSperviseur', [this.selectedSupervisor]);
      } finally {
        this.mBufferMode = 'determinate';
      }
    }
  }

  get imgSupervisor(): SafeUrl | null { return this.mImgSupervisor; }
  get isImgLoaded(): boolean { return this.mImgSupervisor != null; }
  get isRefreshingSupervisor(): boolean { return this.mBufferMode == 'query'; }
  get HTML_ShowImg(): boolean { return (this.mImgSupervisor != undefined) && (this.mImgSupervisor != ''); }
  get bufferMode(): string { return this.mBufferMode; }

}

interface SupervirorInfo {
  Index: number;
  Libele: string;
}
